import React from "react";
import { getSegmentListKey2, segmentListIsInLists } from '../../../amorg-common';
import { SurveySegment } from '../../../amorg-common';
import { SegmentListView, SegmentListViewData } from "./listView/SegmentListView";
import { SegmentationViewMode } from "../../../utils/amorgLocalStorage";

type EditableSegmentPanelProps = {
    segmentLists: {
        segments: SurveySegment[],
        answerCount: number;
    }[],
    selection: SurveySegment[][],
    disableEdit?: boolean,
    noSelectionContent?: React.ReactNode,
    displayAnswerCount?: boolean,
    wrapInCard?: boolean,
    lockedView?:SegmentationViewMode,
    localStorageViewModeKey?: string,
    onSelectionChange: (selectedSegmentLists: SurveySegment[][]) => void;
};

export function EditableSegmentPanel (props: EditableSegmentPanelProps): JSX.Element 
{
    const [listData, setListData] = React.useState<SegmentListViewData[]>([]);

    React.useEffect(()=> {

        const newViewData = props.segmentLists.map(sl => ({
            segments: sl.segments,
            identifier: getSegmentListKey2(sl.segments),
            selected: segmentListIsInLists(props.selection, sl.segments),
            answerCount: sl.answerCount
        }));

        setListData(newViewData);
    }, [props.segmentLists, props.selection]);

    function handleClickToggleAll()
    {
        props.segmentLists.length === props.selection.length
            ? props.onSelectionChange([])
            : props.onSelectionChange(props.segmentLists.map(sl => sl.segments));
    }

    function handleSelectionChanged (identifier: string, selected: boolean)
    {
        const match = listData.find(sl => getSegmentListKey2(sl.segments) === identifier);
        if (match)
        {
            if(selected)
            {
                props.onSelectionChange(
                    [
                        ...listData.filter(ld => ld.selected).map(ld => ld.segments),
                        match.segments
                    ]
                );
            }
            else {
                props.onSelectionChange(
                    listData.filter(ld => ld.selected && getSegmentListKey2(ld.segments) !== identifier).map(ld => ld.segments)
                );
            }
        }
    }

    return (
        <>
            <SegmentListView wrapInCard={props.wrapInCard}
                lockedView={props.lockedView}
                segmentLists={listData}
                onToggleSelect={props.disableEdit || !props.onSelectionChange
                    ? undefined
                    : handleSelectionChanged
                }
                onToggleAll={props.disableEdit || !props.onSelectionChange
                    ? undefined
                    : handleClickToggleAll
                }
                displayAnswerCount={props.displayAnswerCount}
                noSelectionContent={props.noSelectionContent}
                localStorageViewModeKey={props.localStorageViewModeKey}
            />
        </>
    );
}